import {createAction} from 'redux-actions';
import * as ACTION from './constants';

export const getBagPackingDetail = createAction(ACTION.GET_BAG_PACKING_DETAIL.REQUEST, (id) => ({id}));
export const clearState = createAction(ACTION.CLEAR_PACKING_BAG_STATE, () => {});